import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=3c7ac355&"
import script from "./Canvas.vue?vue&type=script&lang=ts&"
export * from "./Canvas.vue?vue&type=script&lang=ts&"
import style0 from "./Canvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports